import { List } from 'immutable';
import { companyDocTypeConstants } from '../constants';

export function company_doc_types(state = {}, action) {
  switch (action.type) {
    case companyDocTypeConstants.COMPANY_DOC_TYPE_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case companyDocTypeConstants.COMPANY_DOC_TYPE_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case companyDocTypeConstants.COMPANY_DOC_TYPE_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };
    case companyDocTypeConstants.COMPANY_DOC_TYPE_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case companyDocTypeConstants.COMPANY_DOC_TYPE_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case companyDocTypeConstants.COMPANY_DOC_TYPE_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case companyDocTypeConstants.COMPANY_DOC_TYPE_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case companyDocTypeConstants.COMPANY_DOC_TYPE_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const companyDocTypeIndex = state.items.findIndex(val => val.id == action.response.id);

      if (companyDocTypeIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(companyDocTypeIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case companyDocTypeConstants.COMPANY_DOC_TYPE_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case companyDocTypeConstants.COMPANY_DOC_TYPE_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case companyDocTypeConstants.COMPANY_DOC_TYPE_DELETE_SUCCESS: {
      const { companyDocTypeId } = action;

      if (!state.items) {
        return state;
      }

      const companyDocTypeIndex = state.items.findIndex(val => val.id == companyDocTypeId);

      if (companyDocTypeIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(companyDocTypeIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case companyDocTypeConstants.COMPANY_DOC_TYPE_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case companyDocTypeConstants.COMPANY_DOC_TYPE_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
